import { defineMessages } from 'react-intl';

export const messages: {
	unicodeReactionAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	imageReactionFallbackLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	unicodeReactionAriaLabel: {
		id: 'search-page.common.ui.top-reaction.unicode-reaction-aria-label',
		defaultMessage: '{emojiName} reaction',
		description:
			'Accessible label for a Slack top reaction shown as a standard emoji on a search result',
	},
	imageReactionFallbackLabel: {
		id: 'search-page.common.ui.top-reaction.image-reaction-fallback-label',
		defaultMessage: 'Like',
		description:
			'Fallback label for a top reaction image when the source does not provide an emoji name',
	},
});
